import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Switch,
  FormControlLabel,
  Button,
  Typography,
  IconButton,
  Grid,
  Tooltip,
  Stack,
  InputAdornment,
} from "@mui/material";
import { TimeField, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Sidebar from "../Layout/Sidebar";
import Topbar from "../Layout/Topbar";
import { ToastContainer, toast } from "react-toastify";
import { Breadcrumb } from "react-bootstrap";
import Loader from "../Common/Loader";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./WorkShiftTemplate.css";
import { useEffect, useRef } from "react";
import { apiRequest } from "../../services/api";
import { encryptData } from "../Common/encryptionUtils";
import { AccessLog } from "../../Utils/AccessLog";

const ShiftCard = ({ shift, index, onChange, onDelete, errors }) => {
  return (
    <Card
      elevation={10}
      sx={{
        borderRadius: 4,
        overflow: "hidden",
        mb: 4,
        marginLeft: "15px",
        border: "1px solid #ddd",
        boxShadow: "0 12px 30px rgba(0,0,0,0.1)",
        // transition: "transform 0.1s ease, box-shadow 0.1s ease",
        "&:hover": {
          //   transform: "scale(1.03)",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: shift.shift_color,
          color: "#fff",
          px: 3,
          py: 1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #ccc",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="h6" fontWeight={600} sx={{ fontSize: "15px" }}>
            Shift #{index + 1}
          </Typography>
          <Tooltip title="Shift Color">
            <Box
              sx={{
                position: "relative",
                width: "100px",
                height: "24px",
                borderRadius: "4px",
                overflow: "hidden",
                border: "1px solid #ddd",
                backgroundColor: shift.shift_color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontWeight: 600,
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              <input
                type="color"
                value={shift.shift_color}
                onChange={(e) => onChange(index, "shift_color", e.target.value)}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  opacity: 0,
                  cursor: "pointer",
                }}
              />
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Typography variant="body2" sx={{ border: "none", p: "5px" }}>
                  {shift.shift_color}
                </Typography>

                <i className="fas fa-edit" style={{ fontSize: "12px" }}></i>
              </Box>
            </Box>
          </Tooltip>
        </Box>

        {index !== 0 && !shift.fromApi && (
          <IconButton
            color="inherit"
            onClick={() => onDelete(index)}
            sx={{ fontSize: "18px" }}
          >
            <i className="fas fa-trash-alt deleteShfitBtn"></i>
          </IconButton>
        )}
      </Box>

      <CardContent
        sx={{ padding: "25px 25px 0px 25px" }}
        className="WorkShiftMainDiv"
      >
        <Grid container spacing={3}>
          {/* Shift Name First */}
          <Grid item xs={12} md={4}>
            <TextField
              label="Shift Name"
              variant="outlined"
              fullWidth
              required
              value={shift.shift_name}
              error={errors?.shift_name}
              helperText={errors?.shift_name && "Shift name is required"}
              onChange={(e) => onChange(index, "shift_name", e.target.value)}
              autoFocus
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <i className="fas fa-clipboard-list"></i>
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                sx: {
                  fontSize: "1rem",
                  fontWeight: 600,
                  color: "#4a90e2 !important",
                  "& .MuiInputLabel-asterisk": {
                    color: "red", // 🔴 only the asterisk is red
                  },
                },
              }}
              sx={{
                "& .MuiInputBase-root": {
                  height: "50px",
                },
              }}
            />
          </Grid>

          <Grid item xs={6} md={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Tooltip title="Start Time (24hrs)">
                <TimeField
                  label="Start Time (24hrs)"
                  value={shift.start_time}
                  onChange={(value) => onChange(index, "start_time", value)}
                  format="HH:mm"
                  fullWidth
                  required
                  error={!!errors?.start_time} // Display error if validation fails
                  helperText={errors?.start_time ? errors.start_time : ""}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <i className="fas fa-clock"></i>
                      </InputAdornment>
                    ),
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: "1rem",
                      fontWeight: 600,
                      color: "#4a90e2 !important",
                      "& .MuiInputLabel-asterisk": {
                        color: "red", // 🔴 only the asterisk is red
                      },
                    },
                  }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      fontSize: "1rem", // <-- Increase label font size here
                      fontWeight: 600,
                      color: "#4a90e2 !important",
                    },
                    "& .MuiInputBase-root": {
                      height: "50px", // Reduce height if needed
                    },
                  }}
                />
              </Tooltip>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={6} md={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Tooltip title="End Time (24hrs)">
                <TimeField
                  label="End Time (24hrs)"
                  value={shift.end_time || null}
                  onChange={(value) => onChange(index, "end_time", value)}
                  format="HH:mm"
                  fullWidth
                  required
                  error={!!errors?.end_time} // Display error if validation fails
                  helperText={errors?.end_time ? errors.end_time : ""}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <i className="fas fa-clock"></i>
                      </InputAdornment>
                    ),
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: "1rem",
                      fontWeight: 600,
                      color: "#4a90e2 !important",
                      "& .MuiInputLabel-asterisk": {
                        color: "red", // 🔴 only the asterisk is red
                      },
                    },
                  }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      fontSize: "1rem", // <-- Increase label font size here
                      fontWeight: 600,
                      color: "#4a90e2 !important",
                    },
                    "& .MuiInputBase-root": {
                      height: "50px", // Reduce height if needed
                    },
                  }}
                />
              </Tooltip>
            </LocalizationProvider>
          </Grid>

          {/* Day Off Switch */}
          <Grid item xs={6} md={2}>
            <Typography
              variant="body1"
              color="text.primary"
              className="bluetooth-label label-switch userFormlabel workShiftLabel"
            >
              Mark as Day Off
            </Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={shift.day_off}
                  onChange={(e) => onChange(index, "day_off", e.target.checked)}
                />
              }
              label=""
            />
          </Grid>

          {/* Shift Enabled Switch */}
          <Grid item xs={6} md={2}>
            <Typography
              variant="body1"
              color="text.primary"
              className="bluetooth-label label-switch userFormlabel workShiftLabel"
            >
              Shift Enabled
            </Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={shift.status}
                  disabled
                  sx={{
                    cursor: "not-allowed",
                    "& .MuiSwitch-thumb": {
                      cursor: "not-allowed",
                    },
                    "& .MuiSwitch-track": {
                      cursor: "not-allowed",
                    },
                  }}
                />
              }
              label=""
            />
          </Grid>
          {/* Shift Color */}
        </Grid>
      </CardContent>
    </Card>
  );
};

const WorkShiftTemplate = () => {
  const authToken = localStorage.getItem("authToken");
  const selectedTopBarPremises = JSON.parse(
    localStorage.getItem("selectedTopBarPremises")
  );
  console.log("selectedTopBarPremises-->", selectedTopBarPremises);
  const [isNewShiftAdded, setIsNewShiftAdded] = useState(false);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );
  const handlePremiseSelect = (selected) => {
    if (selected?.value) {
      setSelectedPremise(selected);
      console.log("selected-->", selected);
      if (selected?.scheduler_feature == "false") {
        navigate("/dashboard");
      } else {
        fetchShiftTemplates(selected?.value);
      }
    }
  };
  const defaultShift = {
    shift_name: "",
    start_time: null,
    end_time: null,
    day_off: false,
    status: true,
    shift_color: "#2d64bc",
    fromApi: false,
  };

  const [shifts, setShifts] = useState([defaultShift]);
  const shiftEndRef = useRef(null);

  const [errorsList, setErrorsList] = useState([{}]);

  const handleChange = (index, field, value) => {
    const updatedShifts = [...shifts];
    const updatedErrors = [...errorsList];
    const newErrors = { ...updatedErrors[index] };

    // Format time fields to HH:mm:ss
    if ((field === "start_time" || field === "end_time") && value) {
      // Ensure it's in HH:mm format and convert to HH:mm:ss
      const formattedTime = value.length === 5 ? `${value}:00` : value;
      updatedShifts[index][field] = formattedTime;
    } else {
      updatedShifts[index][field] = value;
    }

    // Field-level validation
    if (field === "shift_name" && !value) {
      newErrors.shift_name = "Shift name is required";
    } else if (field === "start_time" && !value) {
      newErrors.start_time = "Start time is required";
    } else if (field === "end_time" && !value) {
      newErrors.end_time = "End time is required";
    } else {
      delete newErrors[field]; // Clear field-specific error if valid
    }

    updatedErrors[index] = newErrors;
    setShifts(updatedShifts);
    setErrorsList(updatedErrors);
  };

  const onChange = (index, field, value) => {
    const updatedShifts = [...shifts];
    updatedShifts[index] = {
      ...updatedShifts[index], // ✅ keeps the existing data
      [field]: value,
    };
    setShifts(updatedShifts);
  };

  const validateShift = (shift) => {
    const errors = {};

    // Check if shift name is provided
    if (!shift.shift_name?.trim()) errors.shift_name = "Shift name is required";

    // Check if start time is provided
    if (!shift.start_time) {
      errors.start_time = "Start time is required";
    } else if (!dayjs(shift.start_time, "HH:mm", true).isValid()) {
      errors.start_time = "Invalid start time format. Expected HH:mm";
    }

    // Check if end time is provided
    if (!shift.end_time) {
      errors.end_time = "End time is required";
    } else if (!dayjs(shift.end_time, "HH:mm", true).isValid()) {
      errors.end_time = "Invalid end time format. Expected HH:mm";
    }

    // Check if end time is greater than start time
    if (
      shift.start_time &&
      shift.end_time &&
      shift.end_time.isBefore(shift.start_time)
    ) {
      errors.end_time = "End time cannot be earlier than start time";
    }

    return errors;
  };

  const addShift = () => {
    if (!selectedTopBarPremises?.value) {
      toast.info(
        "No premises are available. Please create a premise before adding a shift.",
        {
          position: "top-right",
          autoClose: 6000,
        }
      );
      return;
    }

    let hasErrors = false;
    const newErrorsList = shifts.map((shift) => {
      const errors = validateShift(shift);
      if (Object.keys(errors).length > 0) {
        hasErrors = true;
      }
      return errors;
    });

    if (hasErrors) {
      setErrorsList(newErrorsList); // Show all validation errors
      return; // Block adding new shift
    }

    // Add new shift if all existing are valid
    setShifts([
      ...shifts,
      {
        shift_name: "",
        shift_color: "#2d64bc",
        day_off: false,
        start_time: null,
        end_time: null,
        status: true,
        fromApi: false,
      },
    ]);
    setErrorsList([...newErrorsList, {}]); // Add an empty error object for new shift
    setIsNewShiftAdded(true);
  };

  const deleteShift = (index) => {
    const updatedShifts = shifts.filter((_, i) => i !== index);
    const updatedErrors = errorsList.filter((_, i) => i !== index);
    setShifts(updatedShifts);
    setErrorsList(updatedErrors);
  };

  const formatToTimeOnly = (value) => {
    const date = new Date(value);
    return date.toTimeString().split(" ")[0]; // "HH:mm:ss"
  };

  const handleSubmit = () => {
    let hasErrors = false;
    const newErrorsList = shifts.map((shift) => {
      const errors = validateShift(shift);
      if (Object.keys(errors).length > 0) {
        hasErrors = true;
      }
      return errors;
    });

    if (hasErrors) {
      setErrorsList(newErrorsList); // Show validation errors
      return; // Prevent submission
    }

    // Format start_time and end_time to HH:mm:ss before submission
    // const formattedShifts = shifts.map((shift) => ({
    //   ...shift,
    //   start_time: formatToTimeOnly(shift.start_time),
    //   end_time: formatToTimeOnly(shift.end_time),
    // }));
    handleSubmitToAPI();

    // Continue with API call using formattedShifts
  };

  const handleReset = () => {
    setShifts([defaultShift]); // Reset to one default shift
    setErrorsList([{}]); // Clear any validation errors
  };

  useEffect(() => {
    fetchShiftTemplates(selectedTopBarPremises?.value);
    AccessLog("Define Shifts");
  }, []);

  useEffect(() => {
    if (isNewShiftAdded && shiftEndRef.current) {
      shiftEndRef.current.scrollIntoView({ behavior: "smooth" });
      setIsNewShiftAdded(false); // ✅ reset flag after scrolling
    }
  }, [isNewShiftAdded]);

  const fetchShiftTemplates = async (premise_id) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const apiResponse = await apiRequest(
        `api/user/getUserShiftTemplatesByPremiseId?premise_id=${encryptData(
          premise_id?.toString()
        )}&type=${encryptData("console")}`,
        "GET",
        null,
        headers
      );

      if (
        apiResponse?.data?.status_code === 200 &&
        apiResponse?.data?.data?.user_shift_templates_details
      ) {
        if (apiResponse?.data?.data?.user_shift_templates_details?.length > 0) {
          const mappedShifts =
            apiResponse?.data?.data?.user_shift_templates_details.map(
              (shift) => ({
                ...shift,
                start_time: dayjs(shift.start_time, "HH:mm"),
                end_time: dayjs(shift.end_time, "HH:mm"),
                day_off: shift.day_off === "true" ? true : false,
                status: shift.status === "enabled" ? true : false,
                fromApi: true,
              })
            );
          setShifts(mappedShifts);
          setErrorsList(mappedShifts.map(() => ({})));
        } else {
          setShifts([defaultShift]);
        }
      } else {
        setShifts([defaultShift]);
        toast.error("Invalid response from server");
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      setLoading(false);
    }
  };

  const prepareShiftPayload = (premiseId, shifts) => {
    return {
      premise_id: encryptData(premiseId),
      arrayofUserShiftTemplates: shifts.map((shift) => ({
        user_shift_templates_id: shift.user_shift_templates_id
          ? encryptData(shift.user_shift_templates_id.toString())
          : encryptData(""),
        shift_name: encryptData(shift.shift_name),
        shift_color: shift.shift_color, // If no encryption needed for color
        day_off: encryptData(shift.day_off.toString()), // "true"/"false"
        start_time: encryptData(formatToTimeOnly(shift.start_time)),
        end_time: encryptData(formatToTimeOnly(shift.end_time)),
        status: encryptData(shift.status ? "enabled" : "disabled"),
      })),
    };
  };

  const handleSubmitToAPI = async () => {
    setLoading(true);
    const encryptedPayload = prepareShiftPayload(
      selectedTopBarPremises?.value?.toString(),
      shifts
    );

    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      console.log("encryptedPayload-->", encryptedPayload);
      const apiResponse = await apiRequest(
        "/api/user/addEditUserShiftTemplatesByPremiseId",
        "POST",
        encryptedPayload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        const handleFetchAndToast = async () => {
          // Step 1: Call fetchShiftTemplates and wait for it to finish
          await fetchShiftTemplates(selectedTopBarPremises?.value);

          // Step 2: Show success message after 1 second delay
          setTimeout(() => {
            toast.success(apiResponse.data.message, {
              position: "top-right",
              autoClose: 4000,
            });
          }, 500);
        };

        // Call the async function
        handleFetchAndToast();
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-layout">
      <Sidebar selectedPremise={selectedPremise} />
      <div className="main-content dashboardMain">
        <Topbar onPremiseSelect={handlePremiseSelect} />
        <ToastContainer />
        {loading && <Loader />}
        <div className="content">
          <div className="contentHeader d-flex align-items-center gap-3 pb-3">
            <div className="contentDiv">
              <Breadcrumb className="contentTitle">
                <Breadcrumb.Item active>Work Shift</Breadcrumb.Item>
                <Breadcrumb.Item active>Define Shifts</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <Box
                maxWidth="1100px"
                mx="auto"
                className="workLocaionMainBox"
                sx={{ backgroundColor: "#fafafa", maxWidth: "auto" }}
              >
                <Stack
                  direction="row"
                  justifyContent="center"
                  mt={3}
                  className="addShiftDiv"
                >
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<i className="fas fa-plus addShiftBtnIcon"></i>}
                    onClick={addShift}
                    className="addShiftBtn"
                    sx={{
                      borderRadius: 1.5,
                      textTransform: "capitalize",
                      px: 4,
                      py: 1.5,
                      fontWeight: 600,
                      backgroundColor: "#2d64bc",
                      "&:hover": {
                        backgroundColor: "#2d64bc",
                      },
                    }}
                  >
                    Add Shift
                  </Button>

                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className="addShiftBtn"
                    onClick={handleSubmit}
                    sx={{
                      borderRadius: 1.5,
                      textTransform: "capitalize",
                      px: 4,
                      py: 1.5,
                      fontWeight: 600,
                      marginLeft: "20px",
                      backgroundColor: "#2d64bc",
                      "&:hover": {
                        backgroundColor: "#2d64bc",
                      },
                    }}
                  >
                    Submit
                  </Button>
                </Stack>
                <Box
                  sx={{
                    maxHeight: "calc(100vh - 220px)",
                    overflowY: "auto",
                    paddingRight: "8px",
                    marginLeft: "-15px",
                  }}
                >
                  {shifts.map((shift, index) => (
                    <ShiftCard
                      key={index}
                      index={index}
                      shift={shift}
                      onChange={handleChange}
                      onDelete={deleteShift}
                      errors={errorsList[index] || {}}
                    />
                  ))}
                  <div ref={shiftEndRef} />
                </Box>
                <Stack
                  direction="row"
                  justifyContent="center"
                  mt={3}
                  className="submitShiftDiv"
                >
                  {/* <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className="addShiftBtn"
                    onClick={handleReset}
                    sx={{
                      borderRadius: 1.5,
                      textTransform: "capitalize",
                      px: 4,
                      py: 1.5,
                      mx: 2,
                      fontWeight: 600,
                      backgroundColor: "#9e9e9e", // Grey color
                      color: "#fff",
                      "&:hover": {
                        backgroundColor: "#7e7e7e", // Darker grey on hover
                      },
                    }}
                  >
                    Reset
                  </Button> */}
                </Stack>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkShiftTemplate;
